import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MemberWithRole {
  memberId: number;
  name: string;
  email: string;
  role: string;
}

interface TeamLeadWithRole {
  memberId: number;
  name: string;
  role: string;
  email?: string;
}

export interface MappedBank {
  organizationId: number;
  name: string;
  logo: string;
  color: string;
  organizationLogo?: string;
  applicationId?: number[];
  applicationName?: string;
  members?: MemberWithRole[];
  teamLead?: TeamLeadWithRole[];
  environment?: string;
}

interface BankState {
  mappedBanks: MappedBank[];
}

const initialState: BankState = {
  mappedBanks: [],
};

const bankSlice = createSlice({
  name: "bank",
  initialState,
  reducers: {
    setMappedBanksvalues: (state, action: PayloadAction<MappedBank[]>) => {
      state.mappedBanks = action.payload;
    },
    addMappedBank: (state, action: PayloadAction<MappedBank>) => {
      if (
        !state.mappedBanks.find(
          (b) => b.organizationId === action.payload.organizationId
        )
      ) {
        state.mappedBanks.push(action.payload);
      }
    },
    updateMappedBank: (state, action: PayloadAction<MappedBank>) => {
      const index = state.mappedBanks.findIndex(
        (b) => b.organizationId === action.payload.organizationId
      );
      if (index !== -1) {
        state.mappedBanks[index] = action.payload;
      }
    },
    removeMappedBank: (state, action: PayloadAction<number>) => {
      state.mappedBanks = state.mappedBanks.filter(
        (b) => b.organizationId !== action.payload
      );
    },
    clearMappedBanks: (state) => {
      state.mappedBanks = [];
    },
  },
});

export const {
  setMappedBanksvalues,
  addMappedBank,
  updateMappedBank,
  removeMappedBank,
  clearMappedBanks,
} = bankSlice.actions;

export default bankSlice.reducer;
